"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UTILITIES_MAPPING = void 0;
exports.UTILITIES_MAPPING = {
    'align-content': {
        center: 'content-center',
        'flex-start': 'content-start',
        'flex-end': 'content-end',
        'space-between': 'content-between',
        'space-around': 'content-around',
        'space-evenly': 'content-evenly',
        baseline: 'content-baseline',
    },
    'align-items': {
        'flex-start': 'items-start',
        'flex-end': 'items-end',
        center: 'items-center',
        baseline: 'items-baseline',
        stretch: 'items-stretch',
    },
    'align-self': {
        auto: 'self-auto',
        'flex-start': 'self-start',
        'flex-end': 'self-end',
        center: 'self-center',
        stretch: 'self-stretch',
        baseline: 'self-baseline',
    },
    appearance: {
        none: 'appearance-none',
    },
    'background-attachment': {
        fixed: 'bg-fixed',
        local: 'bg-local',
        scroll: 'bg-scroll',
    },
    'background-blend-mode': {
        normal: 'bg-blend-normal',
        multiply: 'bg-blend-multiply',
        screen: 'bg-blend-screen',
        overlay: 'bg-blend-overlay',
        darken: 'bg-blend-darken',
        lighten: 'bg-blend-lighten',
        'color-dodge': 'bg-blend-color-dodge',
        'color-burn': 'bg-blend-color-burn',
        'hard-light': 'bg-blend-hard-light',
        'soft-light': 'bg-blend-soft-light',
        difference: 'bg-blend-difference',
        exclusion: 'bg-blend-exclusion',
        hue: 'bg-blend-hue',
        saturation: 'bg-blend-saturation',
        color: 'bg-blend-color',
        luminosity: 'bg-blend-luminosity',
    },
    'background-clip': {
        'border-box': 'bg-clip-border',
        'padding-box': 'bg-clip-padding',
        'content-box': 'bg-clip-content',
        text: 'bg-clip-text',
    },
    'background-origin': {
        'border-box': 'bg-origin-border',
        'padding-box': 'bg-origin-padding',
        'content-box': 'bg-origin-content',
    },
    'background-repeat': {
        repeat: 'bg-repeat',
        'no-repeat': 'bg-no-repeat',
        'repeat-x': 'bg-repeat-x',
        'repeat-y': 'bg-repeat-y',
        round: 'bg-repeat-round',
        space: 'bg-repeat-space',
    },
    'border-style': {
        solid: 'border-solid',
        dashed: 'border-dashed',
        dotted: 'border-dotted',
        double: 'border-double',
        hidden: 'border-hidden',
        none: 'border-none',
    },
    'border-collapse': {
        collapse: 'border-collapse',
        separate: 'border-separate',
    },
    'box-decoration-break': {
        slice: 'box-decoration-slice',
        clone: 'box-decoration-clone',
    },
    'box-sizing': {
        'border-box': 'box-border',
        'content-box': 'box-content',
    },
    'break-after': {
        auto: 'break-after-auto',
        avoid: 'break-after-avoid',
        all: 'break-after-all',
        'avoid-page': 'break-after-avoid-page',
        page: 'break-after-page',
        left: 'break-after-left',
        right: 'break-after-right',
        column: 'break-after-column',
    },
    'break-before': {
        auto: 'break-before-auto',
        avoid: 'break-before-avoid',
        all: 'break-before-all',
        'avoid-page': 'break-before-avoid-page',
        page: 'break-before-page',
        left: 'break-before-left',
        right: 'break-before-right',
        column: 'break-before-column',
    },
    'break-inside': {
        auto: 'break-inside-auto',
        avoid: 'break-inside-avoid',
        'avoid-page': 'break-inside-avoid-page',
        'avoid-column': 'break-inside-avoid-column',
    },
    clear: {
        left: 'clear-left',
        right: 'clear-right',
        both: 'clear-both',
        none: 'clear-none',
    },
    display: {
        block: 'block',
        'inline-block': 'inline-block',
        inline: 'inline',
        flex: 'flex',
        'inline-flex': 'inline-flex',
        table: 'table',
        'inline-table': 'inline-table',
        'table-caption': 'table-caption',
        'table-cell': 'table-cell',
        'table-column': 'table-column',
        'table-column-group': 'table-column-group',
        'table-footer-group': 'table-footer-group',
        'table-header-group': 'table-header-group',
        'table-row-group': 'table-row-group',
        'table-row': 'table-row',
        'flow-root': 'flow-root',
        grid: 'grid',
        'inline-grid': 'inline-grid',
        contents: 'contents',
        'list-item': 'list-item',
        none: 'hidden',
    },
    'flex-direction': {
        row: 'flex-row',
        'row-reverse': 'flex-row-reverse',
        column: 'flex-col',
        'column-reverse': 'flex-col-reverse',
    },
    'flex-wrap': {
        wrap: 'flex-wrap',
        'wrap-reverse': 'flex-wrap-reverse',
        nowrap: 'flex-nowrap',
    },
    float: {
        right: 'float-right',
        left: 'float-left',
        none: 'float-none',
    },
    'font-smoothing': {
        antialiased: 'antialiased',
        grayscale: 'antialiased',
        auto: 'subpixel-antialiased',
    },
    'font-style': {
        italic: 'italic',
        normal: 'not-italic',
    },
    'font-variant-numeric': {
        normal: 'normal-nums',
        ordinal: 'ordinal',
        'slashed-zero': 'slashed-zero',
        'lining-nums': 'lining-nums',
        'oldstyle-nums': 'oldstyle-nums',
        'proportional-nums': 'proportional-nums',
        'tabular-nums': 'tabular-nums',
        'diagonal-fractions': 'diagonal-fractions',
        'stacked-fractions': 'stacked-fractions',
    },
    'grid-auto-flow': {
        row: 'grid-flow-row',
        column: 'grid-flow-col',
        dense: 'grid-flow-dense',
        'row dense': 'grid-flow-row-dense',
        'column dense': 'grid-flow-col-dense',
    },
    isolation: {
        isolate: 'isolate',
        auto: 'isolation-auto',
    },
    'justify-content': {
        'flex-start': 'justify-start',
        'flex-end': 'justify-end',
        center: 'justify-center',
        'space-between': 'justify-between',
        'space-around': 'justify-around',
        'space-evenly': 'justify-evenly',
    },
    'justify-items': {
        'flex-start': 'justify-items-start',
        'flex-end': 'justify-items-end',
        start: 'justify-items-start',
        end: 'justify-items-end',
        center: 'justify-items-center',
        stretch: 'justify-items-stretch',
    },
    'justify-self': {
        auto: 'justify-self-auto',
        'flex-start': 'justify-self-start',
        'flex-end': 'justify-self-end',
        start: 'justify-self-start',
        end: 'justify-self-end',
        center: 'justify-self-center',
        stretch: 'justify-self-stretch',
    },
    'list-style-position': {
        inside: 'list-inside',
        outside: 'list-outside',
    },
    'mix-blend-mode': {
        normal: 'mix-blend-normal',
        multiply: 'mix-blend-multiply',
        screen: 'mix-blend-screen',
        overlay: 'mix-blend-overlay',
        darken: 'mix-blend-darken',
        lighten: 'mix-blend-lighten',
        'color-dodge': 'mix-blend-color-dodge',
        'color-burn': 'mix-blend-color-burn',
        'hard-light': 'mix-blend-hard-light',
        'soft-light': 'mix-blend-soft-light',
        difference: 'mix-blend-difference',
        exclusion: 'mix-blend-exclusion',
        hue: 'mix-blend-hue',
        saturation: 'mix-blend-saturation',
        color: 'mix-blend-color',
        luminosity: 'mix-blend-luminosity',
        'plus-lighter': 'mix-blend-plus-lighter',
    },
    'object-fit': {
        contain: 'object-contain',
        cover: 'object-cover',
        fill: 'object-fill',
        none: 'object-none',
        'scale-down': 'object-scale-down',
    },
    'outline-style': {
        solid: 'outline',
        dashed: 'outline-dashed',
        dotted: 'outline-dotted',
        double: 'outline-double',
    },
    outline: {
        '2px solid transparent': 'outline-none',
    },
    overflow: {
        auto: 'overflow-auto',
        hidden: 'overflow-hidden',
        clip: 'overflow-clip',
        visible: 'overflow-visible',
        scroll: 'overflow-scroll',
    },
    'overflow-wrap': {
        // normal: 'break-normal',
        'break-word': 'break-words',
    },
    'overflow-x': {
        auto: 'overflow-x-auto',
        hidden: 'overflow-x-hidden',
        clip: 'overflow-x-clip',
        visible: 'overflow-x-visible',
        scroll: 'overflow-x-scroll',
    },
    'overflow-y': {
        auto: 'overflow-y-auto',
        hidden: 'overflow-y-hidden',
        clip: 'overflow-y-clip',
        visible: 'overflow-y-visible',
        scroll: 'overflow-y-scroll',
    },
    'overscroll-behavior': {
        auto: 'overscroll-auto',
        contain: 'overscroll-contain',
        none: 'overscroll-none',
    },
    'overscroll-behavior-x': {
        auto: 'overscroll-x-auto',
        contain: 'overscroll-x-contain',
        none: 'overscroll-x-none',
    },
    'overscroll-behavior-y': {
        auto: 'overscroll-y-auto',
        contain: 'overscroll-y-contain',
        none: 'overscroll-y-none',
    },
    'place-content': {
        center: 'place-content-center',
        start: 'place-content-start',
        end: 'place-content-end',
        'space-between': 'place-content-between',
        'space-around': 'place-content-around',
        'space-evenly': 'place-content-evenly',
        baseline: 'place-content-baseline',
        stretch: 'place-content-stretch',
    },
    'place-items': {
        start: 'place-items-start',
        end: 'place-items-end',
        center: 'place-items-center',
        baseline: 'place-items-baseline',
        stretch: 'place-items-stretch',
    },
    'place-self': {
        auto: 'place-self-auto',
        start: 'place-self-start',
        end: 'place-self-end',
        center: 'place-self-center',
        stretch: 'place-self-stretch',
    },
    'pointer-events': {
        none: 'pointer-events-none',
        auto: 'pointer-events-auto',
    },
    position: {
        static: 'static',
        fixed: 'fixed',
        absolute: 'absolute',
        relative: 'relative',
        sticky: 'sticky',
    },
    resize: {
        none: 'resize-none',
        vertical: 'resize-y',
        horizontal: 'resize-x',
        both: 'resize',
    },
    'scroll-behavior': {
        auto: 'scroll-auto',
        smooth: 'scroll-smooth',
    },
    'scroll-snap-align': {
        start: 'snap-start',
        end: 'snap-end',
        center: 'snap-center',
        none: 'snap-align-none',
    },
    'scroll-snap-type': {
        none: 'snap-none',
        'x var(--tw-scroll-snap-strictness)': 'snap-x',
        x: 'snap-x',
        'y var(--tw-scroll-snap-strictness)': 'snap-y',
        y: 'snap-y',
        'both var(--tw-scroll-snap-strictness)': 'snap-both',
        both: 'snap-both',
    },
    'scroll-snap-stop': {
        normal: 'snap-normal',
        always: 'snap-always',
    },
    'table-layout': {
        auto: 'table-auto',
        fixed: 'table-fixed',
    },
    'text-align': {
        left: 'text-left',
        center: 'text-center',
        right: 'text-right',
        justify: 'text-justify',
        start: 'text-start',
        end: 'text-end',
    },
    'text-decoration-line': {
        underline: 'underline',
        overline: 'overline',
        'line-through': 'line-through',
        none: 'no-underline',
    },
    'text-decoration-style': {
        solid: 'decoration-solid',
        double: 'decoration-double',
        dotted: 'decoration-dotted',
        dashed: 'decoration-dashed',
        wavy: 'decoration-wavy',
    },
    'text-transform': {
        uppercase: 'uppercase',
        lowercase: 'lowercase',
        capitalize: 'capitalize',
        none: 'normal-case',
    },
    'text-overflow': {
        ellipsis: 'text-ellipsis',
        clip: 'text-clip',
    },
    'touch-action': {
        auto: 'touch-auto',
        none: 'touch-none',
        'pan-x': 'touch-pan-x',
        'pan-left': 'touch-pan-left',
        'pan-right': 'touch-pan-right',
        'pan-y': 'touch-pan-y',
        'pan-up': 'touch-pan-up',
        'pan-down': 'touch-pan-down',
        'pinch-zoom': 'touch-pinch-zoom',
        manipulation: 'touch-manipulation',
    },
    transform: {
        'translateZ(0)': 'transform-gpu',
        'translate3d(0,0,0)': 'transform-gpu',
        none: 'transform-none',
    },
    'user-select': {
        none: 'select-none',
        text: 'select-text',
        all: 'select-all',
        auto: 'select-auto',
    },
    'vertical-align': {
        baseline: 'align-baseline',
        top: 'align-top',
        middle: 'align-middle',
        bottom: 'align-bottom',
        'text-top': 'align-text-top',
        'text-bottom': 'align-text-bottom',
        sub: 'align-sub',
        super: 'align-super',
    },
    visibility: {
        visible: 'visible',
        hidden: 'invisible',
        collapse: 'collapse',
    },
    'white-space': {
        normal: 'whitespace-normal',
        nowrap: 'whitespace-nowrap',
        pre: 'whitespace-pre',
        'pre-line': 'whitespace-pre-line',
        'pre-wrap': 'whitespace-pre-wrap',
    },
    'word-break': {
        normal: 'break-normal',
        'break-all': 'break-all',
        'keep-all': 'break-keep',
    },
};
